import { axiosInstance as axios } from "services";

export const fetchCategoryAllSeries = async (params) => {
  const { data } = await axios.get("/pricing/master/labor", { params });
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch labor data");
  return data;
};

